import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { FormTextField } from '../../common/Form/FormTextField';
import EditDeckCardRow from './EditDeckCardRow';

function EditDeckBody({
  isLoading,
  title,
  onTitleChange,
  cards,
  isCardNew,
  isCardEdited,
  onFieldChange,
  onRemove,
  onAddBelow,
}) {
  if (isLoading) {
    return (
      <>
        <Skeleton variant="text" width={80} height={24} />
        <Skeleton variant="rectangular" height={40} sx={{ mb: 2 }} />
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} variant="rectangular" height={80} sx={{ mb: 1, borderRadius: 1 }} />
        ))}
      </>
    );
  }

  return (
    <>
      <Box className="titleField">
        <FormTextField
          id="editDeck__field_title"
          label="Deck Title"
          ariaLabel="Deck Title"
          value={title}
          onChange={(event) => onTitleChange(event.target.value)}
          fullWidth
        />
      </Box>

      {cards.map((card, cardIndex) => (
        <EditDeckCardRow
          key={cardIndex}
          card={card}
          cardIndex={cardIndex}
          isNew={isCardNew(card)}
          isEdited={isCardEdited(card)}
          onFieldChange={onFieldChange}
          onRemove={onRemove}
          onAddBelow={onAddBelow}
        />
      ))}
    </>
  );
}

export default EditDeckBody;
